<template>
     <ButtonPopoverMenu
            v-if="parameterOptions.length > 0"
            :items="parameterOptions"
        >
        <template #button="{open}">
            <RoundActionButton
                    :modelClass="modelClass"
                    :invertedColors="invertedColors"
                    :iconSize="iconSize"
                    :icon="icon"
                />
        </template>
        </ButtonPopoverMenu>
</template>

<script>
import ButtonPopoverMenu from '@/Components/Utilities/ButtonPopoverMenu.vue'
import RoundActionButton from '@/Components/ModelComponents/RoundActionButton.vue'
import { PhPlus } from '@phosphor-icons/vue'
import { markRaw } from 'vue'

export default {
    components: {
        ButtonPopoverMenu,
        RoundActionButton,
        PhPlus,
        markRaw
    },

    props: {
        modelClass: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            default: {},
        },
        dataOptions: {
            type: Array,
            default: [],
        },
        iconSize: {
            type: String,
            default: 'size-4',
        },
        iconWeight: {
            type: String,
            default: 'bold'
        },
        invertedColors: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            icon: markRaw(PhPlus),
        }
    },
    computed: {
        parameterOptions() {
            return this.dataOptions.map((item) => ({
                text: item.text,
                href: this.url,
                // Merge the data from the button with the data from the dataOptions
                data: { ...this.data, ...item.data },
                type: 'link',
            }))
        },
    }
}


</script>